import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import './Auth.css'

export default function Login() {
  const { signIn } = useApp()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await signIn(email, password)
    setLoading(false)
    if (error) return setError(error.message)
    navigate('/dashboard')
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">STOP <span>PACANELE</span></div>
        <h1>Bine ai revenit</h1>
        <p className="auth-sub">Continua progresul tau.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="field">
            <label>Email</label>
            <input
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@exemplu.com"
              required
            />
          </div>
          <div className="field">
            <label>Parola</label>
            <input
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Parola ta"
              required
            />
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" className="btn-primary btn-full" disabled={loading}>
            {loading ? 'Se autentifica...' : 'Autentifica-te'}
          </button>
        </form>

        <p className="auth-switch">
          Nu ai cont? <Link to="/register">Inregistreaza-te gratuit</Link>
        </p>
      </div>
    </div>
  )
}
